import { render, staticRenderFns } from "./DiscardSetup.vue?vue&type=template&id=243cb00b&scoped=true&"
import script from "./DiscardSetup.vue?vue&type=script&lang=js&"
export * from "./DiscardSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243cb00b",
  null
  
)

export default component.exports